import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "./api";

const DEFAULTS = {
  practice_name: "A-Tech Architectural Design",
  portal_name: "A-Tech Client Portal",
  logo_url: "/atech-logo.png",
  login_eyebrow: "Client sign-in",
  login_headline: "Technical Design for the Built Environment",
  login_body:
    "A-Tech Architectural Design delivers complete design packages from concept to completion, combining technical expertise, practical built-environment knowledge, and one-to-one project support. This client portal provides a secure, straightforward place to access project information, drawings, and shared documents.",
  login_footer:
    "Access is by invitation. If you don't have an account, please contact A-Tech directly.",
  login_side_caption:
    "Premium document sharing for commercial, heritage, healthcare and council architecture.",
  default_theme: "dark",
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {}, setSettings: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULTS, ...data });
    } catch (_e) { /* pre-auth fetch can fail silently; defaults remain */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(
    () => ({ settings, setSettings, refresh }),
    [settings, setSettings, refresh],
  );

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
